// Load optional components only when their markup exists, including fragments
// inserted by the theme editor, filters, and quick-add dialogs.
const config = document.getElementById('sam-optional-components');
if (config) {
  const pending = new Map(Object.entries(JSON.parse(config.textContent)));
  let selector = [...pending.keys()].join(',');
  const loading = new Set();
  let observer;
  function scan(root) {
    if (!selector || !(root instanceof Element || root instanceof Document)) return;
    const elements = root instanceof Element && root.matches(selector) ? [root] : [];
    elements.push(...root.querySelectorAll(selector));
    for (const element of elements) {
      const tag = element.localName;
      const url = pending.get(tag);
      if (!url || loading.has(tag)) continue;
      if (customElements.get(tag)) { pending.delete(tag); continue; }
      loading.add(tag);
      import(url).then(() => {
        pending.delete(tag);
        selector = [...pending.keys()].join(',');
        if (!selector) observer?.disconnect();
      }).catch((error) => console.warn(`Unable to load ${tag}`, error))
        .finally(() => loading.delete(tag));
    }
    selector = [...pending.keys()].join(',');
    if (!selector) observer?.disconnect();
  }
  observer = new MutationObserver((records) => {
    for (const record of records) for (const node of record.addedNodes) scan(node);
  });
  scan(document);
  if (selector) observer.observe(document.body, { childList: true, subtree: true });
}
